import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { GlobalService } from '../global.service';

@Injectable({ providedIn: 'root' })
export class VersionGuard implements CanActivate, CanActivateChild {
  private globalService = inject(GlobalService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.checkVersion(state.url);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.checkVersion(state.url);
  }

  private async checkVersion(url: string): Promise<boolean | UrlTree> {
    if (url.startsWith('/public/account/version')) {
      return true;
    }

    const latestVersion = await firstValueFrom(this.globalService.getActiveVersion());
    const currentVersion = this.globalService.currentAppVersion();

    if (latestVersion?.length && currentVersion !== latestVersion[0].number) {
      return this.router.createUrlTree(['/public/account/version']);
    }

    return true;
  }
}
